import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeScreen from '../pages/HomeScreen.vue';
import SignInScreen from '../pages/SignInScreen.vue';
import UserScreen from '../pages/UserScreen.vue';
import AnnouncementScreen from '../pages/AnnouncementScreen.vue';
import JobScheduleScreen from '../pages/JobScheduleScreen.vue';
import LocationScreen from '../pages/LocationScreen.vue';
import MachineScreen from '../pages/MachineScreen.vue';
import MachineDetailScreen from '../pages/MachineDetailScreen.vue';
import MachineTemplateScreen from '../pages/MachineTemplateScreen.vue';
import MachineTemplateDetailScreen from '../pages/MachineTemplateDetailScreen.vue';
import ProductScreen from '../pages/ProductScreen.vue';
import ProductDetailScreen from '../pages/ProductDetailScreen.vue';
import ShopScreen from '../pages/ShopScreen.vue';
import VendingMachineScreen from '../pages/VendingMachineScreen.vue';
import SparePartScreen from '../pages/SparePartScreen.vue';
import RoleScreen from '../pages/RoleScreen.vue';
import CommissionLogScreen from '../pages/CommissionLogScreen.vue';
import AppPermissionScreen from '../pages/AppPermissionScreen.vue';
import AppPermissionDetailScreen from '../pages/AppPermissionDetailScreen.vue';
import RefillServiceScreen from '../pages/RefillServiceScreen.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeScreen',
    component: HomeScreen
  },
  {
    path: '/signin',
    name: 'SignInScreen',
    component: SignInScreen
  },
  {
    path: '/users/:tab',
    name: 'UserScreen',
    component: UserScreen
  },
  {
    path: '/announcements',
    name: 'AnnouncementScreen',
    component: AnnouncementScreen
  },
  {
    path: '/job-schedule',
    name: 'JobScheduleScreen',
    component: JobScheduleScreen
  },
  {
    path: '/locations',
    name: 'LocationScreen',
    component: LocationScreen
  },
  {
    path: '/machines',
    name: 'MachineScreen',
    component: MachineScreen
  },
  {
    path: '/machines/:id',
    name: 'MachineDetailScreen',
    component: MachineDetailScreen
  },
  {
    path: '/machine-templates',
    name: 'MachineTemplateScreen',
    component: MachineTemplateScreen
  },
  {
    path: '/machine-templates/:id',
    name: 'MachineTemplateDetailScreen',
    component: MachineTemplateDetailScreen
  },
  {
    path: '/products',
    name: 'ProductScreen',
    component: ProductScreen
  },
  {
    path: '/products/:id',
    name: 'ProductDetailScreen',
    component: ProductDetailScreen
  },
  {
    path: '/vending-machines',
    name: 'VendingMachineScreen',
    component: VendingMachineScreen
  },
  {
    path: '/spare-parts',
    name: 'SparePartScreen',
    component: SparePartScreen
  },
  {
    path: '/shops',
    name: 'ShopScreen',
    component: ShopScreen
  },
  {
    path: '/roles',
    name: 'RoleScreen',
    component: RoleScreen
  },
  {
    path: '/commission-log',
    name: 'CommissionLogScreen',
    component: CommissionLogScreen
  },
  {
    path: '/app-permission',
    name: 'AppPermissionScreen',
    component: AppPermissionScreen
  },
  {
    path: '/app-permission/:id',
    name: 'AppPermissionDetailScreen',
    component: AppPermissionDetailScreen
  },
  {
    path: '*', // All unknown route redirect to home
    redirect: '/'
  },
  {
    path: '/refill-service',
    name: 'RefillServiceScreen',
    component: RefillServiceScreen
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
